'use client'
import { useEffect } from 'react'

export type TypeNextjsPageError = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: TypeNextjsPageError) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    // global-error must include html and body tags
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  )
}
